export default "__VITE_ASSET__CXyplo_L__"